import React from 'react';
import ServiceTemplate from './ServiceTemplate';

const Malerarbeiten = () => {
  const pageData = {
    title: 'MALERARBEITEN',
    subtitle: 'Professionelle Leistung',
    description: 'Hochwertige Malerarbeiten für Innen- und Außenbereiche in Cazis und Graubünden. Von der Fassade bis zum Wohnzimmer – wir sorgen für perfekte Ergebnisse.',
    heroImage: 'https://images.unsplash.com/photo-1516962080544-eac695c93791?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwxfHx3YWxsJTIwcGFpbnRpbmclMjByb2xsZXIlMjB3aGl0ZSUyMGludGVyaW9yJTIwcmVub3ZhdGlvbnxlbnwwfHx8fDE3Nzc2Mjk5NDJ8MA&ixlib=rb-4.1.0&q=85',
    features: [
      { title: 'Innenanstrich', description: 'Wände, Decken und Holzelemente in höchster Qualität streichen.' },
      { title: 'Außenanstrich', description: 'Wetterbeständige Fassadenanstriche mit langlebigen Farben.' },
      { title: 'Lackierarbeiten', description: 'Präzise Lackierung von Türen, Fenstern und Möbeln.' },
      { title: 'Farbberatung', description: 'Professionelle Beratung bei der Farbauswahl für Ihr Projekt.' },
      { title: 'Vorbereitung', description: 'Sorgfältige Untergrundvorbereitung für perfekte Haftung.' },
      { title: 'Schutzmaßnahmen', description: 'Kompletter Schutz Ihrer Möbel und Böden während der Arbeit.' }
    ],
    benefits: [
      'Verwendung hochwertiger Markenfarben',
      'Saubere und präzise Ausführung',
      'Termingerechte Fertigstellung',
      'Kostenlose Farbberatung vor Ort',
      'Langjährige Erfahrung',
      'Faire Preise ohne versteckte Kosten'
    ],
    process: [
      { title: 'Beratung', description: 'Kostenlose Besichtigung und Farbberatung bei Ihnen vor Ort.' },
      { title: 'Angebot', description: 'Detailliertes und transparentes Angebot innerhalb von 24h.' },
      { title: 'Vorbereitung', description: 'Abdecken, Abkleben und Untergrundvorbereitung.' },
      { title: 'Ausführung', description: 'Professioneller Anstrich nach höchsten Qualitätsstandards.' }
    ],
    gallery: [
      'https://images.unsplash.com/photo-1594925985452-dbf35b132b79?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwyfHxjb25zdHJ1Y3Rpb24lMjB3b3JrZXIlMjBwYWludGluZyUyMHdhbGwlMjBoaWdoJTIwcXVhbGl0eXxlbnwwfHx8fDE3NzM3MzY1NDl8MA&ixlib=rb-4.1.0&q=85'
    ],
    metaKeywords: 'Maler Cazis, Malerarbeiten Graubünden, Innenanstrich, Außenanstrich, Fassadenanstrich'
  };

  return <ServiceTemplate {...pageData} />;
};

export default Malerarbeiten;